import { Analytika } from "@analytika/analytika-web";
import { v4 as uuidv4 } from "uuid";
import { PhoneHasher } from "./utils/phoneHasher";
import i18n from "i18next";
import { ANALYTIKA_EVENTS } from "./utils/constants";

if (typeof window !== "undefined") {
  const env = process.env.REACT_APP_ANALYTIKA_ENV;
  Analytika.init(env, false, {}, 10, 10);

  if (typeof document.visibilityState !== 'undefined') {
    document.addEventListener("visibilitychange", function () {
      // fires when user switches tabs, apps, goes to homescreen, etc.
      if (document.visibilityState === "hidden") {
        Analytika.getInstance().flush();
      }
    });
  }
}

class EventAnalytics {
  constructor() {
    this.invoiceId = undefined;
    this.sessionUuid = uuidv4();
    this.phoneNumber = undefined;
    this.hashedPhoneNumber = null;
    this.hashedPhoneNumberPromise = null;
    this.phoneCountry = undefined;
    this.intent = undefined;
    this.page_name = undefined;
    this.flow_name = undefined;
    this.globalAttrs = {
      sessionUuid: this.sessionUuid,
      appName: process.env.REACT_APP_ANALYTIKA_EVENT_SOURCE,
      userAgent: navigator.userAgent,
      careem_identity_device_id: "not_available",
      client_id: "not_defined",
    };
  }

  publishV2(event, eventData) {
    if (!this.hashedPhoneNumberPromise) {
      this.doPublish(event, eventData, this.hashedPhoneNumber);
      return Promise.resolve();
    }
    return this.hashedPhoneNumberPromise.then((hashedPhoneNumber) => {
      this.doPublish(event, eventData, hashedPhoneNumber);
    });
  }

  doPublish(event, eventData, hashedPhoneNumber) {
    Analytika.publish({
      event_name: event.event_name,
      event_version: event.event_version ?? 1,
      signature: event.signature,
      event_trigger_time: new Date().getTime(),
      invoice_id: this.invoiceId,
      hashed_phone_number: hashedPhoneNumber,
      intent: this.intent,
      flow_name: this.flow_name,
      page_name: this.getPageName(),
      language: i18n.language,
      session_id: this.sessionUuid,
      ...(this.phoneCountry && { phone_country: this.phoneCountry }),
      ...this.globalAttrs,
      ...eventData,
    });
  }
  flush() {
    return Analytika.getInstance().flush();
  }

  publishViewPage(page_name, extraAttrs) {
    return this.publishV2(ANALYTIKA_EVENTS.IDNW_VIEW_PAGE, {
      page_name,
      ...extraAttrs,
    });
  }
  setInvoiceId(invoiceId) {
    this.invoiceId = invoiceId;
  }

  setIntent(intent) {
    this.intent = intent;
  }

  setFlowName(flow_name) {
    this.flow_name = validFlowNames.includes(flow_name) ? flow_name : "phone";
  }

  setPageName(page_name) {
    this.page_name = page_name || "not_available";
  }

  setPhoneNumber(phoneNumber) {
    this.phoneNumber = phoneNumber;
    if (!phoneNumber) {
      this.hashedPhoneNumber = null;
      this.hashedPhoneNumberPromise = null;
      return;
    }
    this.hashedPhoneNumber = null;
    this.hashedPhoneNumberPromise = PhoneHasher.sha256Hex(phoneNumber).then(
      (hash) => {
        this.hashedPhoneNumber = hash;
        this.hashedPhoneNumberPromise = null;
        return hash;
      }
    );
  }

  setDeviceId(device_id) {
    this.globalAttrs.careem_identity_device_id = device_id;
  }

  setClientId(clientId) {
    this.globalAttrs.client_id = clientId || "not_defined";
  }

  getPageName() {
    return this.page_name || "not_available";
  }

  getSessionUuid() {
    return this.sessionUuid;
  }

  setPhoneCountry(phoneCountry) {
    this.phoneCountry = phoneCountry;
  }
}

const validFlowNames = [
  "apple",
  "biometric",
  "email",
  "google",
  "guest",
  "one_click",
  "phone",
];

const eventAnalytics = new EventAnalytics();
export default eventAnalytics;
